<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <!--<img src="@/assets/img/back.png" alt="">-->
        <span style="color: #FFFFFF">消息</span>
      </p>
    </header>
    <div style="margin-top: 70px">
      <van-tabs v-model="activeName" @click="onClick">
        <van-tab title="已邀请" name="1">
          <div class="messageCenter" v-for="(index,key) in list" @click="toMessage(index.user_id)">
            <div class="communicate">
              <img :src="index.photo" alt="">
            </div>
            <div style="width: 100%;padding-left: 14px" class="">
              <!--<div><span style="color:#639DD5">韩多多</span><span style="color:#BEBEBE;margin-left: 1rem;font-size: 12px ">十二栋</span></div>-->
              <!--{{index}}-->
              <div class="communicateTop">
                <span style="color:#639DD5">{{index.resume_name}}</span>
                <span style="float: right;font-size: 13px">{{index.create_time}}</span>
              </div>
              <!--<div class="communicateRight">-->
                <!--<span > {{index.city}}</span>-->
                <!--<span v-if="index.company_name"> |{{index.company_name}}</span>-->
              <!--</div>-->
              <div class="communicateRight">
                <!--<span > 13-15K</span>-->
                <p v-if="index.workexperience">{{index.workexperience.positionname}}·{{index.workexperience.name}}</p>
              </div>
             </div>
          </div>
          <!--内容 1-->
          <!--<div style="margin-top: 70px">-->

          <!--</div>-->
        </van-tab>
        <van-tab title="被投递" name="2">
          <div class="messageCenter" v-for="(index,key) in list">
            <div class="communicate">
              <img :src="index.photo" alt="">
            </div>
            <div style="width: 100%;padding-left: 14px" class="">
              <!--<div><span style="color:#639DD5">韩多多</span><span style="color:#BEBEBE;margin-left: 1rem;font-size: 12px ">十二栋</span></div>-->
              <!--{{index}}-->
              <div class="communicateTop">
                <span style="color:#639DD5">{{index.resume_name}}</span>
                <span style="float: right;font-size: 13px">{{index.create_time}}</span>
              </div>
              <!--<div class="communicateRight">-->
                <!--<span > {{index.city}}</span>-->
                <!--<span v-if="index.company_name"> |{{index.company_name}}</span>-->
              <!--</div>-->
              <div class="communicateRight">
                <!--<span > 13-15K</span>-->
                <!--<p>{{index.workexperience.positionname}}·{{index.workexperience.name}}</p>-->
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="待沟通" name="3"></van-tab>
        <van-tab title="面试" name="4"></van-tab>
        <van-tab title="不合适" name="5"></van-tab>
      </van-tabs>
    </div>
    <van-tabbar route v-model="active">
      <van-tabbar-item replace to="/comTalents" icon="wap-home-o">
        招人才
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMessage" icon="envelop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/comPosition" icon="desktop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMy" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        activeName: 1,
        active:0,
        list:[
          {workexperience:{positionname:''}}
        ]
      }
    },
    mounted(){
    this.getcomMessage()
    this.getcomMessage1()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toMessage(id){
         this.$router.push({
           path:"/comMessageDtails",
           query:{
             id:id
           }
         })
      },
      onClick(name){
      console.log(name)
        console.log()
        this.getcomMessage()
      },
      getcomMessage(){ //职位信息
        console.log(this.activeName)
        this.$api.companySendList({
          "company_id":localStorage.getItem("companyId"),
          "status":this.activeName
        })
          .then(res=>{
//            if(res.status==200){
            this.list=res.data
            console.log(res)
//              this.id=res.data.id
//              console.log(this.data)
//            }
          })
      },
      getcomMessage1(){ //职位信息
        console.log(this.activeName)
        this.$api.getcomMessage({
          "company_id":localStorage.getItem("companyId"),
          "status":this.activeName
        })
          .then(res=>{
//            if(res.status==200){
//            this.list=res.data
//            console.log(res)
//              this.id=res.data.id
//              console.log(this.data)
//            }
          })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    padding: 0;
    margin: 0;
  }
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .messageHeader{
    width: 100%;
    background-color: #6e9bcf;
    position: fixed;
    top:0;
  }
  .messageTopDiv{
    display: flex;
    justify-content: space-around;
    margin-top: 2rem;
  }
  .messageTop{
    /*width: 15%;*/
    text-align: center;
    color: #FFFFFF;
  }
  .messageClear{
    color: #FFFFFF;
    /*width: 39%;*/
    text-align: center;
    /*text-align: center;*/
    display: flex;
    align-items: center;
    /*justify-content: center*/
  }
  .messageCenter{
    /*margin-top: 75px;*/
    display: flex;
    align-items: center;
    width: 85%;
    margin: auto;
    padding-top: 2rem;
  }
  .communicate{
    width: 50px;
    /*height: 50px;*/
    /*border-radius:100% ;*/
  }
  .communicate img{
    width: 100%;
    /*width: 100%;*/
    border-radius: 100%;
  }
  .communicateRight{
    /*display: flex;*/
    /*display: flex;*/
    /*justify-content: space-between;*/
    padding-top: 6px;
    font-size: 12px;
    color: #8f8f94;
  }
.communicateTop{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/company/comMessage.vue